export default __webpack_public_path__ + "static/SiemensProgress-Bol-master-5a201c34af3756b46a49a3131c739488.woff2";